import firebase from '../../firebase';

export default async function getRidesSample(params) {
    return firebase.functions().httpsCallable('rides-getExportSample')(params);
}
